import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  inject,
  Input,
} from '@angular/core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { map, Observable, switchMap } from 'rxjs';
import { TaskWorkspaceStore } from '../../../h3ml/state/task-workspace-store';
import { ObjectSelectionService } from '../../../outputs/annotation/annotation-shared/utils/object-selection.service';
import { ObjectScopingService } from '../../../shared/misc-services/object-scoping.service';

@Component({
  selector: 'h3-selectable-object',
  templateUrl: './selectable-object.component.html',
  styleUrl: './selectable-object.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class SelectableObjectComponent
  extends DirectiveSuperclass
  implements AfterViewInit
{
  @Input({ required: true }) objectIndex!: number;
  @Input() padding = 24; // SPACING_05

  private readonly taskWorkspaceStore = inject(TaskWorkspaceStore);

  isSelected$: Observable<boolean> = this.getInput$('objectIndex').pipe(
    switchMap((objectIndex) =>
      this.taskWorkspaceStore('objectSelection')(objectIndex).$.pipe(
        map((isObjectSelected) => isObjectSelected === true),
      ),
    ),
  );

  private objectSelectionService = inject(ObjectSelectionService);
  private objectScopingService = inject(ObjectScopingService);

  private elementRef = inject(ElementRef);
  private preventScrollIntoView = false;

  @HostListener('click')
  onClick() {
    this.preventScrollIntoView = true;
    this.objectSelectionService.setSelection([this.objectIndex]);
    this.objectScopingService.scopeIntoView(this.objectIndex);
  }

  ngAfterViewInit() {
    this.subscribeTo(this.isSelected$, (isSelected) => {
      if (isSelected && !this.preventScrollIntoView) {
        this.elementRef.nativeElement.scrollIntoView({ behavior: 'smooth' });
      }
      this.preventScrollIntoView = false;
    });
  }
}
